import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonLinksStorage } from './common-links-storage';
import { CommonLink } from './common-link';

@Component({
    selector: 'common-links',
    template: require('./common-links.component.html'),
    styles: [require('./common-links.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonLinksComponent implements OnInit {
    public commonLinks: Observable<CommonLink[]>;

    constructor(private commonLinksStorage: CommonLinksStorage) { }

    public ngOnInit() {
        this.commonLinks = this.commonLinksStorage.all;
    }
}